module.exports = __webpack_public_path__ + "static/media/quote.3bc1a194.svg";